import React from 'react';
import {File as FWFile} from 'FW/Models/File';
import _ from 'underscore';
import {hoc} from 'Page/Sections/BlogPreview/BlogPreview';
import '../../../../../../_lib/dotdotdot/dist/jquery.dotdotdot';

class BlogPreview extends React.Component{

  componentDidMount(){
    // better text truncation
    $('.post-content').dotdotdot();
  }

  componentDidUpdate(){
    // better text truncation
    $('.post-content').dotdotdot();
  }

  render(){
    let posts = this.props.posts.map((post) => {
      let backgroundUrl;
      let imageId = post.get('thumbnail_image') ? post.get('thumbnail_image') : post.get('featured_image');
      if (imageId){
        let background = FWFile.findOrCreate({id: imageId});
        backgroundUrl = background.helper.thumbnailUrl(800);
      } else {
        backgroundUrl = null;
      }

      const opts = this.props.section.prop('basic_options') || {};

      let styleDefaults = {
        height: opts.height || '230px',
        display: 'block',
        backgroundSize: opts.background_size || 'cover',
        backgroundPosition: opts.background_position || 'center',
        backgroundRepeat: 'no-repeat'
      };
      let style = backgroundUrl ? _.defaults(styleDefaults, {backgroundImage: 'url(' + backgroundUrl + ')'}) : styleDefaults;

      let advancedOptions = this.props.section.get('properties').advanced_options || {};

      return <div key={'post-' + post.get('id')} className="col-md-6 col-md-4 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="800ms">
        <div className="post-thumb">
          <a href={post.getUrl()} style={style}/>
          <div className="entry-header">
            <h3><a href={post.getUrl()}>{post.get('title')}</a></h3>
            <span className="date"/>
          </div>
          <div className="entry-content">
            <div className="post-content" style={{maxHeight: 200}}>
              <p dangerouslySetInnerHTML={{__html: post.getPreview(advancedOptions.characters_to_display, opts.show_all_line_breaks)}}></p>
            </div>
            <a href={post.getUrl()} className="btn btn-default" role="button">Read More</a>
          </div>
        </div>
      </div>;
    });

    return (
      <span className="col-md-12">
        {posts}
      </span>
    );
  }

}

export default hoc(BlogPreview);
